import React, { useEffect } from 'react';
import { MapContainer, TileLayer, WMSTileLayer, Marker, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { MAPTILER_TILE_URL, ADMIN_BOUNDARIES_WMS, PLACE_LABELS_WMS } from '../../config/mapConfig';

delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const MINIMAP_ZOOM = 4; // fixed country-level zoom

/** Forces Leaflet to recalculate map size after the container finishes rendering. */
const MapResizer: React.FC = () => {
  const map = useMap();
  useEffect(() => {
    const t = setTimeout(() => map.invalidateSize(), 100);
    return () => clearTimeout(t);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
};

const LocationMarker = ({ position }: { position: [number, number] }) => {
  const map = useMap();
  useEffect(() => { map.flyTo(position, MINIMAP_ZOOM); }, [position]); // eslint-disable-line react-hooks/exhaustive-deps
  return <Marker position={position} />;
};

interface Props {
  position: [number, number];
  zoomLevel?: number;
  MapClickHandler?: React.ComponentType;
}

const maptilerUrl = MAPTILER_TILE_URL;
const adminBoundariesWMS = ADMIN_BOUNDARIES_WMS;
const placeLabelsWMS = PLACE_LABELS_WMS;

export const MiniMap: React.FC<Props> = ({ position, MapClickHandler }) => (
  <div style={{ borderRadius: '8px', overflow: 'hidden', border: '1px solid #7e5134', backgroundColor: '#fff' }}>
    <MapContainer
      center={position}
      zoom={MINIMAP_ZOOM}      
      maxZoom={MINIMAP_ZOOM}
      zoomControl={false}
      style={{ height: 'clamp(180px, 25vh, 250px)', width: '100%' }}
    >
      <TileLayer url={maptilerUrl} attribution="&copy; FAO" />
      <WMSTileLayer url={adminBoundariesWMS} layers="bndl" format="image/png" transparent={true} attribution="UN Clear Map" />
      <WMSTileLayer url={placeLabelsWMS} layers="cen_uncountries" format="image/png" transparent={true} />
      <MapResizer />
      <LocationMarker position={position} />
      {MapClickHandler && <MapClickHandler />}
    </MapContainer>
  </div>
);